<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn" v-if="[1, 5].includes(user.user_group_id)">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "driver",
      formInline: {
        iswork: 1,
      },
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "姓名" },
        { keyName: "sex", label: "性别" },
        { keyName: "tel", label: "联系电话" },
        { keyName: "nation", label: "民族" },
        { keyName: "province", label: "籍贯" },
        { keyName: "edu", label: "学历" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/driverDetail?mode=view&id=${id}`);
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/driverDetail?mode=edit&id=${id}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
        {
          icon: "el-icon-link",
          title: "解绑",
          cb: ({ id }) => {
            this.$confirm("真的要解绑微信吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.unBind(id);
              })
              .catch(() => {
                console.log("取消");
              });
          },
        },
      ],
      baseParams: ["iswork"],
      menu: [],
      menuIndex: "",
      value: "",
    };
  },
  computed: {
    ...mapState(["store"]),
  },
  methods: {
    ...mapMutations(["setState"]),
    addItem() {
      this.$router.push(`/staff/driverDetail`);
    },
    unBind(id) {
      const url = `${this.baseUrl}/uplre`;
      const params = {
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg == "success") {
            this.$message({
              type: "success",
              message: "解绑成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "解绑失败，请稍后再试！",
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "解绑失败，请稍后重试！",
          });
        }
      );
    },
    setParams() {
      const { iswork } = this.$route.params;
      this.formInline.iswork = iswork;
      this.page = 1
      this.getList();
    },
    //车队长
    getCaptains() {
      this.loading = true;
      let url = `fixedpay/getfleet`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ fleet }) => {
          this.loading = false;
          this.menu = fleet.map((v, i) => {
            return {
              name: v.nickname,
              path: `/staff/driver/table/${i + 1}`,
              fleet: v.id,
            };
          });
          // if (this.menu.length) {
          //   this.formCtrl[0].options = fleet.map((v) => {
          //     return {
          //       label: v.nickname,
          //       value: v.id,
          //     };
          //   });
          // }
          this.$forceUpdate();
          const { idx } = this.$route.params;
          this.menuIndex = `/staff/driver/table/${idx}`;
          // console.log(this.setState);
          this.setState({
            key: "fleet",
            value: fleet,
          });
          // console.log(this.menuIndex)
          // console.log(this.menu)
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams();
    },
  },
  created() {
    const { user_group_id } = this.user
    if (![1, 5].includes(user_group_id)) {
      this.btns.length = 1
    }
  },
  mounted() {
    // this.getCaptains();
    this.setParams();
  },
};
</script>

<style lang="less" scoped>
</style>
